import React, { useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
    Spinner,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';

function ResultTab({ exams, loading, renderPagination }) {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('semester');


    const handleView = (examId) => {
        navigate(`/admin/subject-result/${examId}`);
    };

    const filteredExams = exams.filter((exam) => (
        activeTab === 'mid' ? exam.isMid === true : exam.isMid !== true
    ));

    return (
        <Container>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <h3>{activeTab === 'mid' ? 'Mid Term Results' : 'Semester Results'}</h3>
                                    <Nav pills>
                                        <NavItem>
                                            <NavLink href="#" active={activeTab === 'semester'} onClick={() => setActiveTab('semester')}>Semester Result</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink href="#" active={activeTab === 'mid'} onClick={() => setActiveTab('mid')}>Mid Term Result</NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            {loading ? (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Spinner color="primary" />
                                </div>
                            ) : (
                                <>
                                    {filteredExams.length === 0 ? (
                                        <p>No exams found.</p>
                                    ) : (
                                        <Table className="table">
                                            <thead>
                                                <tr style={{ backgroundColor: '#2980b9', color: 'white' }}>
                                                    <th>Class</th>
                                                    <th>Course</th>
                                                    <th>Type</th>
                                                    <th>Year</th>
                                                    {/* <th>Status</th> */}
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredExams.map((exam, index) => (
                                                    <tr key={exam._id} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                                                        <td>{exam.class.className}</td>
                                                        <td>{exam.course.courseName}</td>
                                                        <td>{exam?.type?.name || "NA"}</td>
                                                        <td>{exam.year}</td>
                                                        {/* <td>{exam.status === 'draft' ? 'DRAFT' : 'PUBLISHED'}</td> */}
                                                        <td>
                                                            <Button color="info" size="sm" onClick={() => handleView(exam._id)}>
                                                                View
                                                            </Button>
                                                            {/* <Button color="success" size="sm" onClick={handleAlertAdd}>
                                                                Add
                                                            </Button> */}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </>
                            )}
                            {renderPagination()}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ResultTab;
